import { isAbsoluteUrl } from '../../../../utils';
import { CONTENT_REPO_ORIGIN, FALLBACK_IATA_CODE } from './constants';
import { ResponseContentRepoType } from './types';

/**
 * Нормализует относительный путь в content repo: trim, без ведущих `/`, без двойных слэшей.
 */
export const normalizeContentRepoPath = (path: string): string => {
	const trimmed = path.trim().replace(/^\/+/, '');

	return trimmed.replace(/\/+/g, '/');
};

/**
 * Собирает абсолютный URL в content repo для уже проверенного относительного пути.
 */
export const buildContentRepoUrl = (path: string, iataCode: string): string => {
	return `${CONTENT_REPO_ORIGIN}/${iataCode}/${normalizeContentRepoPath(path)}`;
};

/**
 * Резолвит URL для запроса.
 */
export const resolveFetchUrl = (path: string, contentRepo: boolean, iataCode: string): string => {
	const isAbsolute = isAbsoluteUrl(path);

	if (contentRepo && isAbsolute) {
		throw new Error('При contentRepo=true допускаются только относительные пути content repo');
	}

	if (!contentRepo && isAbsolute) {
		return path;
	}

	return buildContentRepoUrl(path, iataCode);
};

/**
 * Собирает массив URL для запроса.
 */
export const getUrlArray = (path: string, fallback: string | undefined, contentRepo: boolean, iataCode: string) => {
	const primaryUrl = resolveFetchUrl(path, contentRepo, iataCode);
	const fallbackUrl = fallback ? resolveFetchUrl(fallback, contentRepo, FALLBACK_IATA_CODE) : undefined;

	return [primaryUrl, ...(fallbackUrl ? [fallbackUrl] : [])];
};

/**
 * Читает тело ответа в зависимости от типа.
 */
export const readResponseBody = async (response: Response, type: ResponseContentRepoType): Promise<unknown> => {
	switch (type) {
		case 'json':
			return response.json();
		case 'text':
			return response.text();
		case 'blob':
			return response.blob();
		case 'arrayBuffer':
			return response.arrayBuffer();
		default: {
			const exhaustive: never = type;

			return exhaustive;
		}
	}
};

/**
 * Загружает данные из URL.
 */
export const loadData = async (
	url: string,
	signal: AbortSignal,
	responseType: ResponseContentRepoType
): Promise<unknown> => {
	const response = await fetch(url, { signal });

	if (!response.ok) {
		throw new Error(`HTTP ${response.status}: ${response.statusText}`);
	}

	return await readResponseBody(response, responseType);
};
